import { Injectable, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication.service';
import { CompanyService } from '@core/services/company.service';
import { TalentLocale, i18nObject } from '@models/locales';
import { Subject } from 'rxjs';

@Pipe({
  name: 'localize',
})
@Injectable({
  providedIn: 'root',
})
export class LocalizePipe implements PipeTransform, OnDestroy {
  private _companyLocale: TalentLocale;
  private _userLocale: TalentLocale;
  private _unsubscribe$ = new Subject<void>();

  constructor(
    private readonly _authService: AuthenticationService,
    private readonly _companyService: CompanyService,
  ) {
    this._authService.currentUser$.subscribe(
      (user) => (this._userLocale = user?.locale),
    );
    this._companyService.currentCompany$.subscribe(
      (company) => (this._companyLocale = company?.defaultLocale),
    );
  }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  transform(translations: i18nObject, snapshot?: TalentLocale): string {
    if (typeof translations === 'string') {
      return translations;
    }

    if (
      translations === null ||
      !translations ||
      Object.keys(translations).length === 0
    ) {
      return;
    }

    return (
      translations[snapshot] ||
      translations[this._userLocale] ||
      translations[this._companyLocale] ||
      Object.values(translations)[0]
    );
  }
}
